// A list stays a list (each object in it pruned too): walked as an object it came out as { "0": … }.
const prune = (value) => Array.isArray(value) ? value.map(prune) : value && typeof value === "object" ? pruneEmpty(value) : value;
const pruneEmpty = (obj) => Object.entries(obj)
    .map(([k, v]) => [k, prune(v)])
    //@ts-ignore
    .reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});

export { pruneEmpty };
